import { render, staticRenderFns } from "./AddOccurrences.vue?vue&type=template&id=0bd54f4e"
import script from "./AddOccurrences.vue?vue&type=script&lang=js"
export * from "./AddOccurrences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports